<div class="header-center-info">
  <h2 class="title">{{shared.res['#RecoverPasswordTitle']}}</h2>
  <p class="title-sub">{{shared.res['#RecoverPasswordDescription']}}</p>
</div>

